import { render, staticRenderFns } from "./DriverListItem.vue?vue&type=template&id=a0e1a848"
import script from "./DriverListItem.vue?vue&type=script&lang=js"
export * from "./DriverListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports